import ContractFormInfo from './ContractFormInfo';

export default ContractFormInfo;
